<template>
  <div>
    <custom-callout
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2"
      :border-color="getStatusColor(value.status)"
      @click:open="toggleAdditionalInfo()"
    >
      <div class="row mt-2">
        <div class="col-md-2 col-12">
          <custom-balloon
            class="mt-sm-3 mx-4 mx-md-0"
            :text="value.status"
            :background-color="getStatusColor(value.status)"
          />
        </div>
        <div class="col-md-10 pt-3">
          <div class="row mobile-row">
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Título:
              </div>
              <p class="info-text">
                {{ value.title }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Materia:
              </div>
              <p class="info-text">
                {{ value.subject }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Grado:
              </div>
              <p class="info-text">
                {{ value.grade }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Medio de Lectura:
              </div>
              <p class="info-text">
                {{ value.readingMedium }}
              </p>
            </div>
            <div class="col-md-4 col-6">
              <div class="info-text-title">
                Pedido:
              </div>
              <p class="info-text">
                {{ value.requested ? 'Sí' : 'No' }}
              </p>
            </div>
            <div v-show="value.requested" class="col-md-4 col-6">
              <div class="info-text-title">
                Razón:
              </div>
              <p class="info-text">
                {{ value.requestReason }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <a
      :ref="`ei-collapse-${value.bookId}`"
      class="hidden"
      data-toggle="collapse"
      :href="`#ei-collapse-${value.bookId}`"
      aria-expanded="false"
      :aria-controls="`ei-collapse-${value.bookId}`"
    />
    <div :id="`ei-collapse-${value.bookId}`" class="collapse">
      <div class="bg-gray p-2">
        <div class="bg-white rounded p-3">
          <b-tabs
            content-class="mt-3"
            :no-nav-style="true"
            nav-class="custom-nav-container"
          >
            <b-tab title="Información Adicional">
              <AdditionalInfo :book="value" />
            </b-tab>
            <b-tab title="Historial de Pedido" />
            <OrderHistory />
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import { Colors } from '@/components/common';
import { AdditionalInfo, OrderHistory } from './tabs';

export default {
  name: 'OrderBookResultRow',
  components: {
    CustomCallout,
    CustomBalloon,
    AdditionalInfo,
    OrderHistory,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    getStatusColor() {
      return (status) => {
        switch (status) {
          case 'Pendiente de Determinación':
            return Colors.YELLOW;
          case 'Pendiente de Compra':
            return Colors.YELLOW;
          case 'Pendiente de Entrega de Centro':
            return Colors.PINK;
          case 'Pendiente de Entrega de Escuela':
            return Colors.PINK;
          case 'Entregado':
            return Colors.GREEN;
          default:
            return Colors.YELLOW;
        }
      };
    },
  },
  methods: {
    toggleAdditionalInfo() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);
      link.click();
      this.isOpen = !isOpen;
    },
    getCollapse() {
      let link = this.$refs[`ei-collapse-${this.value.bookId}`];
      const isOpen = link.getAttribute('aria-expanded') == 'true';
      return { link, isOpen };
    },
    close() {
      let { link, isOpen } = this.getCollapse(this.value.bookId);

      if (isOpen) {
        this.isOpen = false;
        link.click();
      }
    },
  },
};
</script>

<style scoped>
.info-text {
  color: #11291b !important;
  font-weight: 16px;
}
.info-text-title {
  color: #727272 !important;
  font-size: 14px !important;
  font-weight: normal;
}
.orange-icon {
  color: #ff7058;
}

@media only screen and (max-width: 375px) {
  .balloon-container {
    max-width: 60%;
    margin-left: 0px !important;
  }
  .mobile-row {
    float: left;
  }
  .fa-book-open {
    font-size: 21px;
  }

  .info-text {
    color: #11291b !important;
    font-weight: normal;
    font-size: 12px;
  }
  .info-text-title {
    margin-bottom: 0.2rem;
  }
}
</style>
